import superagent from 'superagent';
import config from '../../config';
import _ from 'lodash';
import {SS_KEY} from '../../constants';

export default {
	get(url, query = {}) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.get(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Content-Type', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.query(query)
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	post(url, body = {}) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.post(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Content-Type', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.send(body)
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	patch(url, body = {}) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.patch(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Content-Type', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.send(body)
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	delete(url) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.del(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Content-Type', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	getImage(url) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.get(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Content-Type', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.responseType('blob')
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	uploadImage(url, file) {
		const authToken = this.getAuthToken();
		return new Promise(((resolve, reject) => {
			superagent
				.post(`${config.api}${url}`)
				.set('Accept', 'application/json')
				.set('Authorization', `Bearer ${authToken}`)
				.attach('image', file, file.name)
				.end((error, result) => {
					if (error) {
						return reject({
							error,
							result
						});
					}
					return resolve(result.body);
				});
		}));
	},

	getAuthToken() {
		const authToken = window.sessionStorage.getItem(SS_KEY.AUTH_TOKEN);
		if (_.isNil(authToken) || !_.isString(authToken)) {
			return '';
		}
		return authToken;
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/request.js